// extracted by mini-css-extract-plugin
export default {"container":"PunchupSeatsWidget_container__-HFui"};